var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1825 41.0517V58.8229C73.1825 59.9781 73.1379 61.0888 73.0043 62.155C71.9798 74.1506 64.8971 80.1039 51.8455 80.1039H50.0638C48.9501 80.1039 47.8811 80.6371 47.2129 81.5256L41.8675 88.6341C39.5067 91.7885 35.6758 91.7885 33.3149 88.6341L27.9695 81.5256C27.3904 80.7704 26.0987 80.1039 25.1187 80.1039H23.337C9.1272 80.1039 2 76.5941 2 58.8229V41.0517C2 28.0344 8.01358 20.9703 19.9961 19.9485C21.0652 19.8152 22.1788 19.7707 23.337 19.7707H51.8455C66.0553 19.7707 73.1825 26.8792 73.1825 41.0517Z",
    stroke: "#B5B5B5",
    strokeWidth: 3.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23.281V41.0522C91 54.114 84.9865 61.1336 73.004 62.1554C73.1376 61.0892 73.1821 59.9785 73.1821 58.8233V41.0522C73.1821 26.8797 66.055 19.7712 51.8452 19.7712H23.3368C22.1787 19.7712 21.065 19.8156 19.996 19.9489C21.0205 7.99782 28.1031 2 41.1545 2H69.6631C83.8729 2 91 9.10851 91 23.281Z",
    stroke: "#B5B5B5",
    strokeWidth: 3.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2059 51.9812H53.2644",
    stroke: "#B5B5B5",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6157 51.9812H37.6742",
    stroke: "#B5B5B5",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0254 51.9812H22.0911",
    stroke: "#B5B5B5",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/icon-message.76c18b30264f80e4791bc626815dfe50.svg";
export { ForwardRef as ReactComponent };